import { useAuth } from './useAuth';
import { decodeJwt, rolesFromJwt } from './decodeJwt';

export interface CurrentUser {
  id: string | null;
  email: string | null;
  name: string | null;
  roles: string[];
}

export function useCurrentUser(): CurrentUser {
  const { tokens } = useAuth();
  if (!tokens?.accessToken) return { id: null, email: null, name: null, roles: [] };
  const payload = decodeJwt(tokens.accessToken);
  return {
    id: (payload['nameid'] as string | undefined) ?? null,
    email: (payload['email'] as string | undefined) ?? null,
    name: (payload['unique_name'] as string | undefined) ?? null,
    roles: rolesFromJwt(tokens.accessToken),
  };
}
